/** PURE_IMPORTS_START .._.._Observable,.._.._operator_skipUntil PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { skipUntil } from '../../operator/skipUntil';
Observable.prototype.skipUntil = skipUntil;
//# sourceMappingURL=skipUntil.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/skipUntil.js
// module id = 716
// module chunks = 0